export const DEFlagRound = ({ width = "32px", height = "32px" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#a)">
          <path
            d="M16 32c8.837 0 16-7.163 16-15.999S24.837.002 16 .002C7.166.002.002 7.165.002 16.002c0 8.835 7.164 15.999 16 15.999Z"
            fill="#fff"
          />
          <path
            d="M31.085 10.666h-9.858c.428 3.418.431 7.184.009 10.606h9.87A15.97 15.97 0 0 0 32 16.001a15.96 15.96 0 0 0-.915-5.335Z"
            fill="#D32027"
          />
          <path
            d="M21.227 10.666h9.858l-.005-.014C29.032 4.878 23.765.63 17.437.066c2.449 1.343 3.164 5.596 3.79 10.6Z"
            fill="#0B0B0B"
          />
          <path
            d="M17.437 31.934c6.34-.565 11.615-4.828 13.654-10.617l.016-.046h-9.871c-.622 5.031-1.34 9.315-3.799 10.663Z"
            fill="#F3C515"
          />
          <path
            d="M0 16c0 1.848.317 3.621.893 5.272h21.166c.423-3.422.42-7.188-.008-10.606H.914A15.967 15.967 0 0 0 0 16.001Z"
            fill="#DB2727"
          />
          <path
            d="M.92 10.651a.436.436 0 0 0-.006.014h21.137c-.626-5.004-2.165-9.257-4.614-10.6A16.28 16.28 0 0 0 16 0C9.04 0 3.12 4.445.92 10.651Z"
            fill="#151515"
          />
          <path
            d="M22.06 21.271H.892l.015.046C3.101 27.539 9.028 32 16 32c.484 0 .963-.024 1.437-.066 2.459-1.348 4.001-5.632 4.622-10.663Z"
            fill="#F8D12E"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
